import type { GraphQLError } from 'graphql';

import { query } from '@confluence/query-preloader-tools/entry-points/graphql.ts';

import SmartCreateFeedbackBannerQuery from './__generated__/SmartCreateFeedbackBannerQuery.graphql.ts';

export function preloadSmartCreateFeedbackBanner(contentId: string): Promise<{
	data: unknown;
	errors?: ReadonlyArray<GraphQLError>;
	hasErrors: boolean;
}> {
	return query({
		query: SmartCreateFeedbackBannerQuery,
		variables: {
			contentId,
		},
	});
}
